<template>
  <button
    type="button"
    :class="[
      modelValue ? 'bg-primary' : 'bg-background-fg/50',
      'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent ring-offset-background transition-colors duration-200 ease-in-out disabled:pointer-events-none disabled:bg-background-fg/20',
    ]"
    role="switch"
    aria-checked="false"
    :disabled="disabled"
    @click="emit('update:modelValue', !modelValue)"
  >
    <span
      aria-hidden="true"
      :class="[
        modelValue ? 'translate-x-5' : 'translate-x-0',
        'pointer-events-none inline-block size-5 rounded-full bg-background shadow ring-0 transition duration-200 ease-in-out',
      ]"
    />
  </button>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: boolean
  disabled?: boolean
}>()

const emit = defineEmits<{
  (event: "update:modelValue", value: boolean): void
}>()
</script>
